export default __webpack_public_path__ + "static/media/popcorn.254e6ed4.png";